import { Project } from '@dice/app/constants/router.const';
import { Ng2StateDeclaration } from '@uirouter/angular';

export const EIMA_MODULE_STATE: Ng2StateDeclaration = {
  name: `dice.${Project.EIMA}.**`,
  url: '/eima',
  loadChildren: () => import('@eima/app/eima.module').then((m) => m.EimaModule),
};

export const APP_STATES = [EIMA_MODULE_STATE];
